__webpack_require__.p = "/fund-screener/Content/dist_components/mfe/";